import { render, staticRenderFns } from "./SearchArtworks.vue?vue&type=template&id=798e296b&scoped=true"
import script from "./SearchArtworks.vue?vue&type=script&lang=ts"
export * from "./SearchArtworks.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SearchArtworks.vue?vue&type=style&index=0&id=798e296b&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SearchArtworks.vue?vue&type=style&index=1&id=798e296b&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "798e296b",
  null
  ,true
)

export default component.exports